import { defineStore } from "pinia";
import EmbedService from "@/service/EmbedService";
export const useEmbedStore = defineStore("storeEmbed", {
  state: () => {
    return {};
  },
  actions: {
    async getEmbedBySubGroup(id) {
      const embedService = new EmbedService();
      var respeuta = await embedService.getEmbedBySubGroup(id);
      return respeuta;
    },
  },
});
